import { Head } from '@inertiajs/react';
import React from 'react';

interface TestPageProps {
  message: string;
}

const TestPage: React.FC<TestPageProps> = ({ message }) => {
  console.log('✅ TestPage Mounted!');

  return (
    <>
      <Head title="Test Page" /> {/* Set page title */}
      <div className="test-page">
        <h1>🚀 Reacttt Test Page</h1>
        <p>{message}</p>
      </div>
    </>
  );
};

export default TestPage;
